module.exports = __webpack_public_path__ + "img/top-4.508c074.png";